<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium"
                 style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Student Teams</span>
            </div>
            <div style="display: flex; flex: 1; flex-direction: row;">
                <div
                    style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="viewStudentTeams()"><span translate>Go To Teams</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="display: flex;align-items: center; flex: 1; justify-content: center;" *ngIf="studentTeams.length == 0">
                Student is not a member of any teams.
            </div>
            <mat-table style="width: 100%;" *ngIf="studentTeams.length > 0" [dataSource]="studentTeams">
                <!-- Team Column -->
                <ng-container matColumnDef="team">
                    <mat-header-cell *matHeaderCellDef>Team</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.TeamName}} </mat-cell>
                </ng-container>

                <!-- Staff Name Column -->
                <ng-container matColumnDef="staffName">
                    <mat-header-cell *matHeaderCellDef>Staff Name</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.StaffLastName}}, {{element.StaffFirstName}} </mat-cell>
                </ng-container>

                <!-- Entry Column -->
                <ng-container matColumnDef="entry">
                    <mat-header-cell *matHeaderCellDef>Entry</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.EntryDate | date:'MM/dd/yy'}} </mat-cell>
                </ng-container>

                <!-- Exit Column -->
                <ng-container matColumnDef="exit">
                    <mat-header-cell *matHeaderCellDef>Exit</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ExitDate | date:'MM/dd/yy'}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
    </div>
</mat-card>
